import Vue from 'vue'
import App from './App.vue'
import './styles/index.css' //全局css
import 'animate.css'; //引入动画css库
// import '@/utils/flexible'//rem适配
import '@/utils/maidian' //埋点

import loadubgPlugin from '@/utils/cardloading' //全局的自定义loading  开始调用：this.$cardloading(true,'加载中')  结束调用：this.$cardloading(false)
import globalMixin from '@/mixin/beforeupdate' //mixin 混入
import router from './router/index' //路由
import store from './store/index'; //vuex
import MessagePlugin from '@/utils/tips';//全局封装的提示 this.$tips('提示信息')
import ElementUI from 'element-ui'; //element-ui
import 'element-ui/lib/theme-chalk/index.css'; //element-ui的css


import VideoPlayer from 'vue-video-player' //视频播放器一类的
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'



// import 'lib-flexible'
// import VueLazyload from "vue-lazyload";  //图片懒加载

Vue.config.productionTip = false //减少很多控制台的警告


Vue.mixin(globalMixin)
Vue.use(ElementUI);
Vue.use(MessagePlugin);
Vue.use(loadubgPlugin)
Vue.use(VideoPlayer)

// const errorimage = require('assets/img/common/error.gif')
// Vue.use(VueLazyload, {
//   preLoad: 1.3, //预加载的宽高比
//  // loading: loadimage, //图片加载状态下显示的图片
//   // error: errorimage, //图片加载失败时显示的图片
//   attempt: 1, // 加载错误后最大尝试次数
// })
// Vue.use(VueLazyload);

// console.log(router)


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')